module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAABBElEQVR4Ae3RtVkFYRBG4XM9xL0JnDqwECfCtR/cSsAdCkASXDMSPBqCwdmHwfV/v/CsL47j/GkR6lhHENapJfK6bktlFbm3VVLM/go+5pFHm8Vnd2WrRDxWZndlW0Q8Nmt3ZTtFPHZkd2U7MS5g9Ld+ohmzW4yfWGp3ZfOz4PEL/WZ/hTSWH5y+TKrdXydCLesIwhZ1RMz+qzhhcmiil00E3RZ91JNHiIcKOHvUDQGKGdSTPHfCEIUEuJPJpWf34KOabcQe21TjQ0G70RXxjCOv2AgJKD8bz3UVzTryyq0Tjao1OtCJvGFdqAyjA4fIG7aPijE6IG+bef7338DdwHGcP+IKbJGBV42R/j4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Menucontainer/baseline_group_black_24dp.png
// module id = 65
// module chunks = 0